const { __ } = wp.i18n;

window.addEventListener('DOMContentLoaded', () => {
	const headerEl = document.querySelector('.wp-block-mavis-header-content');

	const mobileMenuToggle = document.querySelector('.mavisHeader_menuToggle.is-mobile');
	const tabletMenuToggle = document.querySelector('.mavisHeader_menuToggle.is-tablet');
	const desktopMenuToggle = document.querySelector('.mavisHeader_menuToggle.is-desktop');

	const hiddenTabletNavEls = document.querySelector('.mavisHeader_tabletBottom-collapsibleNav');
	const hiddenMobileNavEls = document.querySelector('.mavisHeader_mobileNavs');

	const mobileFocusableElements = [...hiddenMobileNavEls.querySelectorAll('li')];
	const mobileLastFocusableElement = mobileFocusableElements[mobileFocusableElements.length - 1];

	const tabletFocusableElements = [...hiddenTabletNavEls.querySelectorAll('li')];
	const tabletLastFocusableElement = tabletFocusableElements[tabletFocusableElements.length - 1];

	const hiddenDesktopSearchEl = document.querySelector('.mavisHeader_desktopBottom-search');
	const desktopLastFocusableElement = hiddenDesktopSearchEl.querySelector(
		'button[type="submit"].wp-block-search__button',
	);

	const body = document.querySelector('body');

	const isReduced =
		window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
		window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

	/**
	 * Determines what the toggle button text should be updated to.
	 * @param {Element} el - Toggle button text element.
	 * @returns {string}
	 */
	const toggleText = (el) =>
		el.innerHTML.includes('Menu') ? __('Close', 'mavis') : __('Menu', 'mavis');

	/**
	 * Determines what the toggle button aria-label should be based on the header element state.
	 * @returns {string}
	 */
	const toggleAriaLabel = () =>
		headerEl.classList.contains('is-open') ? __('close menu', 'mavis') : __('open menu', 'mavis');

	/**
	 * Handles the event of a menu toggle click
	 * @param {Element} toggleEl Menu toggle that was clicked.
	 */
	const handleToggleClick = (toggleEl, navsToShow) => {
		const toggleTextEl = toggleEl.querySelector('p');
		// Slight delay on the text change to sync better with the CSS transitions.
		const timeoutDuration = isReduced ? '0' : '100';
		setTimeout(() => {
			toggleTextEl.innerHTML = toggleText(toggleTextEl);
		}, timeoutDuration);
		headerEl.classList.toggle('is-open');
		toggleEl.setAttribute('aria-label', toggleAriaLabel());
		navsToShow.toggleAttribute('inert');
	};

	/**
	 * Creates a focus trap for mobile and tablet menus
	 * @param {event} e keydown event
	 * @param {Element} toggleToFocus the first element for the focus to loop back to
	 */
	const createFocusTrap = (e, toggleToFocus) => {
		const isTabPressed = e.key === 'Tab';

		if (!isTabPressed) {
			return;
		}

		// Shift focus to the first element to give looping effect
		if (isTabPressed && !e.shiftKey) {
			toggleToFocus.focus();
			e.preventDefault();
		}
	};

	/**
	 * Handles the 'Search' toggle on desktop being clicked.
	 */
	const handleSearchToggleClick = (e) => {
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}
		e.preventDefault();

		const toggleTextEl = document.querySelector('.mavisHeader_menuToggle.is-desktop p');
		const wasClosed = toggleTextEl.innerHTML.includes('Search');
		const searchInputEl = hiddenDesktopSearchEl.querySelector('input[type="search"]');

		hiddenDesktopSearchEl.toggleAttribute('inert');
		toggleTextEl.innerHTML = wasClosed ? __('Close', 'mavis') : __('Search', 'mavis');
		desktopMenuToggle.setAttribute(
			'aria-label',
			wasClosed ? __('close search', 'mavis') : __('open search', 'mavis'),
		);
		headerEl.classList.toggle('is-open');

		if (e.type === 'keydown' && wasClosed) {
			searchInputEl.focus();
		}
	};

	mobileMenuToggle.addEventListener('click', () => {
		handleToggleClick(mobileMenuToggle, hiddenMobileNavEls);
	});

	tabletMenuToggle.addEventListener('click', () => {
		handleToggleClick(tabletMenuToggle, hiddenTabletNavEls);
	});

	mobileLastFocusableElement.addEventListener('keydown', (e) =>
		createFocusTrap(e, mobileMenuToggle),
	);

	tabletLastFocusableElement.addEventListener('keydown', (e) =>
		createFocusTrap(e, tabletMenuToggle),
	);

	desktopLastFocusableElement.addEventListener('keydown', (e) =>
		createFocusTrap(e, desktopMenuToggle),
	);

	desktopMenuToggle.addEventListener('click', (e) => handleSearchToggleClick(e));
	desktopMenuToggle.addEventListener('keydown', (e) => {
		handleSearchToggleClick(e);
	});

	body.addEventListener('keydown', (e) => {
		const openMenu = document.querySelector('.wp-block-mavis-header-content.is-open');
		if (e.key !== 'Escape' || !openMenu) {
			return;
		}
		if (window.innerWidth < 720) {
			handleToggleClick(mobileMenuToggle, hiddenMobileNavEls);
			mobileMenuToggle.focus();
		} else if (window.innerWidth >= 720 && window.innerWidth < 940) {
			handleToggleClick(tabletMenuToggle, hiddenTabletNavEls);
			tabletMenuToggle.focus();
		} else if (window.innerWidth >= 940) {
			handleSearchToggleClick();
			desktopMenuToggle.focus();
		}
	});

	/**
	 * Sets the padding-top of the collapsible regions depending on the height of the header content.
	 */
	const setCollapsibleRegionPaddingTop = () => {
		if (window.innerWidth >= 940) {
			hiddenDesktopSearchEl.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
		} else if (window.innerWidth < 940 && window.innerWidth >= 720) {
			hiddenTabletNavEls.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
		} else if (window.innerWidth < 720) {
			hiddenMobileNavEls.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
		}
	};

	// Closes the collapsible sections if the window is resized out of their range.
	// Disabling eslint complexity rule as we need to check these set conditions here.
	/* eslint-disable complexity */
	window.addEventListener('resize', (e) => {
		if (
			window.innerWidth >= 720 &&
			mobileMenuToggle.getAttribute('aria-label') === 'close menu' &&
			headerEl.classList.contains('is-open')
		) {
			handleToggleClick(mobileMenuToggle, hiddenMobileNavEls);
		} else if (
			(window.innerWidth < 720 || window.innerWidth >= 940) &&
			tabletMenuToggle.getAttribute('aria-label') === 'close menu' &&
			headerEl.classList.contains('is-open')
		) {
			handleToggleClick(tabletMenuToggle, hiddenTabletNavEls);
		} else if (
			window.innerWidth < 940 &&
			desktopMenuToggle.getAttribute('aria-label') === 'close search' &&
			headerEl.classList.contains('is-open')
		) {
			hiddenDesktopSearchEl.style.paddingTop = `calc(2rem + ${headerEl.offsetHeight}px + 2rem)`;
			handleSearchToggleClick(e);
		}
		setCollapsibleRegionPaddingTop();
	});
	/* eslint-enable complexity */

	setCollapsibleRegionPaddingTop();
});
